import { getPopupContainer } from '@bimser/core';
import { TimePicker } from 'antd';
import * as React from 'react';
import Styles from './assets/styles.scss';
import { ITimeRangePickerProps } from './entities';
const { RangePicker } = TimePicker;

const BCTimeRangePicker = (props: ITimeRangePickerProps) => {
	Styles;
	const timeRangePicker = React.useRef(null);

	return (
		<RangePicker
			ref={timeRangePicker}
			autoFocus={props.autoFocus}
			className={props.className}
			onChange={props.onChange}
			size={props.size}
			disabled={props.disabled}
			style={props.style}
			value={props.value}
			onBlur={props.onBlur}
			onFocus={props.onFocus}
			getPopupContainer={getPopupContainer}
			order={props.order}
		/>
	);
};
export default BCTimeRangePicker;
